<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item active>{{$t('avances.breadcrumb-1')}}</b-breadcrumb-item>
    </b-breadcrumb>
    <b-tabs class="sm" lazy>
      <b-tab :title="$t('avances.tabTitle.1')" active @click="SeeTabCertificates">
        <h4 class="sub-title"><span>{{$t('avances.sub-title.1')}}</span></h4>
        <b-table hover :items="itemsAssignments"  :busy="isBusy"  :show-empty="true"
         :fields="fieldAssignments" id="tableStudentHistory" :empty-text="$t('reusables.empty-text')">
          <template #table-busy>
						<div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong> {{$t('ClassRequest.Loading')}}...</strong>
            </div>
					</template>
          <template #cell(state)="data">
            <div>
              <p :style="{color:data.item.personsStudentsSubjectHistory.subjectStateValue == 1 ? '#8DBD65' : 
                (data.item.personsStudentsSubjectHistory.subjectStateValue == 2 ? '#D4263A' : '#FDD51C')}">
                {{data.item.personsStudentsSubjectHistory.subjectStateName}}
              </p>
            </div>
          </template>
          <template #cell(urlFile)="data">
            <div v-if="data.item.urlFile">
              <span>
                <a class="link noBorder mr-2" @click="DonwloadFile(data.item.urlFile)">
                  <icon name="certificate" />
                </a>
              </span>
            </div>
            <p v-else style="color:#B7B8BD">N/A</p>
          </template>
          <template #cell(evaluations)="data">
            <a class="link noBorder" @click="redirectEvaluations(data.item.personsStudentsSubjectHistory.id)"><icon name="valid-doc" /></a>
          </template>
        </b-table>
        <div class="overflow-auto content-pagination">
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="pageSize"></b-pagination>
        </div>
      </b-tab>
      <b-tab :title="$t('avances.tabTitle.2')" lazy @click="SeeLevelHistory">
        <h4 class="sub-title"><span>{{$t('avances.sub-title.2')}}</span></h4>
        <b-row v-if="studentLevel">
          <b-col>
            <p style="font-size:15px"><strong class="bold blue">{{$t('avances.date.1')}} </strong>{{studentLevel.person.strFullName}}</p>
          </b-col>
          <b-col>
            <p style="font-size:15px"><strong class="bold blue">{{$t('avances.date.2')}} </strong> {{studentLevel.strLevelCurrent}}</p>
          </b-col>
        </b-row>
        <div class="infoGroup mb-5" v-if="studentLevel">
          <div class="box">
            <p>{{$t('avances.date.3')}} <span>{{studentLevel.levelWritten ? studentLevel.levelWritten.abbreviation : "-"}}</span></p>
          </div>
          <div class="box">
            <p>{{$t('avances.date.4')}} <span>{{studentLevel.levelOral ? studentLevel.levelOral.abbreviation : "-"}}</span></p>
          </div>
          <div class="box">
            <p>{{$t('avances.date.5')}} <span>{{studentLevel.level ? studentLevel.level.abbreviation : "-"}}</span></p>
          </div>
        </div>
        <h6 class="bold blue">{{$t('avances.sub-title.3')}}</h6>
        <b-table hover :items="itemsHistorial"  :busy="isBusy"  :show-empty="true"
         :fields="fieldHistorial" :empty-text="$t('reusables.empty-text')"></b-table>
        <div class="overflow-auto content-pagination">
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="pageSize"></b-pagination>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';

export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      isBusy: false,
      studentLevel: null,
      totalRows: 0,
      fieldAssignments:[
        {key:'personsStudentsSubjectHistory.subjectName' , label:this.$t('avances.table-th-1.1')},
        {key:'personsStudentsSubjectHistory.lastDateScheduleStr' , label:this.$t('avances.table-th-1.2')},
        {key:'state' , label:this.$t('avances.table-th-1.3')},
        {key:'personsStudentsSubjectHistory.strScore' , label:this.$t('avances.table-th-1.4')},
        {key:'urlFile' , label:this.$t('avances.table-th-1.5')},
        {key:'evaluations' , label:this.$t('avances.table-th-1.6'),thStyle:{width:"12%"}}
      ],
      itemsAssignments: [],
      fieldHistorial:[
        {key:'levelCategory.name' , label:this.$t('avances.table-th-2.1')},
        {key:'level.abbreviation' , label:this.$t('avances.table-th-2.2')},
        {key:'dateCreatedString' , label:this.$t('avances.table-th-2.3')},
        {key:'levelObtainBy.name' , label:this.$t('avances.table-th-2.4')},
      ],
      itemsHistorial: []
    }
  },
  watch:{
    currentPage: {
			handler: function(newVal, oldVal) {
				this.GetLevels();
			}
		}
  },
  mounted(){
    this.GetCertificates();
  },
  methods: {
    GetCertificates(){
      this.isBusy = true;
      let params = {
        PersonStudentId: this.$store.state.user.personStudentId,
        Page: this.currentPage,
        Size: this.pageSize
      };

      baseInstanceAxios
        .get(`${this.apiURL}/resources/PersonsAssignmentsEvaluations/ListPersonsSubjectsCertificate`, {params})
        .then(response => {
          if(response.data != null && response.data.list != null){
            this.itemsAssignments = response.data.list;
            this.totalRows = response.data.rows;
            this.isBusy = false;
          }
        }).catch(() =>{
          this.isBusy = false;
        });;
    },
    SeeLevelHistory(){
      this.currentPage = 1;
      this.totalRows = 0;
      this.GetCurrentLevel();
      //this.GetLevels();
    },
    SeeTabCertificates(){
      this.currentPage = 1;
      this.totalRows = 0;
      this.GetCertificates();
    },
    GetLevels(){
      this.isBusy = true;
      let params = {
        PersonStudentId: this.$store.state.user.personStudentId,
        Page: this.currentPage,
        Size: this.pageSize
      };

      baseInstanceAxios
        .get(`${this.apiURL}/resources/PersonsStudents/ListLevelHistoryByPersonsStudents`, {params})
        .then(response => {
          if(response.data != null && response.data.list != null){
            this.itemsHistorial = response.data.list;
            this.totalRows = response.data.rows;
            this.isBusy = false;
          }
        }).catch(() =>{
          this.isBusy = false;
        });
    },
    GetCurrentLevel(){
      this.isBusy = true;
      let params = {
        PersonStudentId: this.$store.state.user.personStudentId,
        Page: this.currentPage,
        Size: this.pageSize
      };

      baseInstanceAxios
        .get(`${this.apiURL}/resources/PersonsStudents/ObtenerPersonsStudentsLevel`, {params})
        .then(response => {
          if(response.data != null && response.data.entity != null){
            this.studentLevel = response.data.entity;
            this.itemsHistorial = response.data.entity.listLevelHistoryByPersonsStudents.list;
            this.totalRows = response.data.entity.listLevelHistoryByPersonsStudents.rows;
            this.isBusy = false;
          }
        });
    },
    DonwloadFile(fileName){
      let headers = { responseType: "blob"};

        baseInstanceAxios
          .get(`${this.apiURL}/Resources/PersonsAssignmentsEvaluations/DownloadFileCertificate?nameFile=${fileName}`, headers)
          .then((response) => {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([response.data]));
            link.setAttribute('download', `${fileName}`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }).catch(() =>{});
    },
    redirectEvaluations(id){
      this.$router.push({name : 'student/evaluaciones', params: {id}}).catch(()=>{});
    }
  }
}
</script>
